export default "__VITE_ASSET__CsvTJQeW__"